<div class="modal-body" style="flex: 1; justify-content: center; align-content: center; ">
    <lottie style="width: 40%; height: auto;margin-left: 30%;" [path]="lottieConfig.path" [loop]="true"></lottie>
    <h2 style="text-align: center;">Caricamento in corso ...</h2>
</div>